import Icon from 'veui/components/Icon'
import { IconGift } from 'dls-icons-vue'

Icon.register('gift', IconGift)
